// extracted by mini-css-extract-plugin
export var component = "GridMenuLink-module--component--lRHUL";
export var label = "GridMenuLink-module--label--hucWT";